import type { WebediaPlayer } from '@webedia-services/webedia-player';

import type { PlayerCustomData } from 'website/module/player';
import {
  loadGemiusLib,
  quartileEventTracking,
  trackerHandler
} from 'website/tracking/player/gemius.internals';
import { getCurrentCustomData } from 'website/tracking/player/utils';

const initGemius = (
  webediaPlayer: WebediaPlayer,
  customData: PlayerCustomData
) => {
  webediaPlayer.addEventListener('ready', loadGemiusLib);
  webediaPlayer.addEventListener('quartile', customEvent => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(webediaPlayer, customEvent, currentCustomData);
  });
  webediaPlayer.addEventListener('quartile-postroll', customEvent => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(webediaPlayer, customEvent, currentCustomData);
  });
  webediaPlayer.addEventListener('seek', () => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    trackerHandler(webediaPlayer, 'seekingStarted', currentCustomData);
  });
  webediaPlayer.addEventListener('buffer', ({ detail: { newstate } }) => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    trackerHandler(webediaPlayer, newstate as EventType, currentCustomData);
  });
};

export default initGemius;
